import React from "react";
import { useK2Loader } from 'hooks/useK2Loader';
import Loader from 'components/Loader';
import Alert from 'react-bootstrap/Alert';
import AdvancedTable from 'components/LM/common/AdvancedTable';
import Breadcrumb from "components/LM/common/Breadcrumb";

import K2Api from 'lib/ajax/K2Api';

const TABLE_COLUMNS = [
	{
		name: "submitted_at",
		alias: "Submitted Date"
	},
	{
		name: "filename",
		alias: "Filename"
	},
	{
		name: "user",
		alias: "User"
	},
	{
		name: "status",
		alias: "Status"
	},
	{
		name: "total_accounts",
		alias: "Total Accounts"
	},
	{
		name: "added",
		alias: "Added"
	},
	{
		name: "existing",
		alias: "Existing"
	},
	{
		name: "error",
		alias: "Error"
	}
];

function OverallStatus(props) {
	const [loading, response, error] = useK2Loader("/socialmedia/import", {params: {from: 0, size: 20}});

	if (loading) return <Loader />;
	if (error) return <Alert variant="danger">{error.toString()}</Alert>

	return <>
		{breadcrumbPage()}
		<AdvancedTable
			columns={TABLE_COLUMNS}
			onSearch={params => doSearch(params)}
			onResults={response => processResponse(response)}
			data={processResponse(response)}
		/>
	</>
}

async function doSearch({ page, pageSize}) {
	const from = (page - 1) * pageSize;
	const request = { from, size: pageSize };

	const k2Api = new K2Api();
	const response = await k2Api.get('/socialmedia/import', { params: request });

	return response.data;
}

function processResponse(response) {
	const rows = response.files.map(item => {
		return {
			id: item.filename,
			submitted_at: item.submitted_at,
			filename: <a href={item.presigned_urls.input}>{item.filename}</a>,
			user: item.user,
			status: <a href={item.presigned_urls.output}>{item.status}</a>,
			total_accounts: item.status === "done" ? `${item.stats?.total}` : "-",
			added: item.status === "done" ? `${item.stats?.added}` : "-",
			existing: item.status === "done" ? `${item.stats?.exists}` : "-",
			error: item.status === "done" ? `${item.stats?.error}` : "-",
		};
	});

	return { total: response.total, rows };
}

function breadcrumbPage() {
	const items = [
		'Orphan',
		<a href="/orphan/import">Mass Import</a>,
		'Import Status'
	  ];
	return <Breadcrumb items={items}/>
}

export default OverallStatus;
